function fixReadMoreButtons() {
  const readMoreBtns = document.querySelectorAll(
    ".more__button:not([data-aria-fixed])",
  );

  readMoreBtns.forEach(function (readMoreBtn) {
    const container = readMoreBtn.closest("li, .product-card, .card");
    let title = "this product";

    if (container) {
      const titleElement = container.querySelector(
        ".product-title, .card__title, h3, h2",
      );
      if (titleElement) {
        title = titleElement.innerText.trim();
      }
    }

    readMoreBtn.setAttribute("aria-label", "Read more about " + title);
    readMoreBtn.setAttribute("data-aria-fixed", "true");
  });
}

// Run once immediately
fixReadMoreButtons();

// Function to find Skeepers and attach a scoped observer
function attachSkeepersObserver() {
  // Adjust this selector to match Skeepers' specific wrapper ID/Class if needed
  const skeepersContainer = document.querySelector(
    '[id*="skeepers"], [class*="skeepers"]',
  );

  if (skeepersContainer) {
    // Observe ONLY the Skeepers container (Zero performance impact)
    const observer = new MutationObserver(function (mutations) {
      let shouldFix = false;
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length > 0) shouldFix = true;
      });
      if (shouldFix) fixReadMoreButtons();
    });

    observer.observe(skeepersContainer, { childList: true, subtree: true });
    return true; // Attached successfully
  }
  return false; // Container not found yet
}

// Wait for window load to ensure Skeepers has had time to mount its container
window.addEventListener("load", function () {
  if (!attachSkeepersObserver()) {
    // If it still hasn't loaded, poll lightly just to find the container, then stop
    const findInterval = setInterval(function () {
      if (attachSkeepersObserver() || /* stop after 5s */ false) {
        clearInterval(findInterval);
      }
    }, 200);

    setTimeout(function () {
      clearInterval(findInterval);
    }, 5000);
  }
});
